import { render, staticRenderFns } from "./ProfilingIntro.vue?vue&type=template&id=5604781e&scoped=true"
import script from "./ProfilingIntro.vue?vue&type=script&lang=js"
export * from "./ProfilingIntro.vue?vue&type=script&lang=js"
import style0 from "./ProfilingIntro.vue?vue&type=style&index=0&id=5604781e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604781e",
  null
  
)

export default component.exports